// extracted by mini-css-extract-plugin
export default {"compoundSpinner":"styles-module__compoundSpinner__src-labstep-web-core-Loader-Logo-_GWErG"};